module.exports = __webpack_public_path__ + "static/media/25-meteorolog.371746ed.mp3";